import { get, writable } from 'svelte/store';

export const loggedIn  = writable(true);
export const setApiUrl = writable(0);
export const tokenTTL  = writable(0);
export const allGroups = writable(0);
const storedSelectedGroup = sessionStorage.getItem("selectedGroup");
export const selectedGroup = writable(storedSelectedGroup);
selectedGroup.subscribe(value => {    
    sessionStorage.setItem("selectedGroup", value === null ? 0 : value);
});
export const currentPage = writable();

const storedGroupHasSubbedVessels = sessionStorage.getItem("groupHasSubbedVessels");
export const groupHasSubbedVessels = writable(storedGroupHasSubbedVessels);
groupHasSubbedVessels.subscribe(value => {    
    sessionStorage.setItem("groupHasSubbedVessels", value === null ? 0 : value);
});

const storedUserSettings = sessionStorage.getItem("userSettings");
export const userSettings = writable(storedUserSettings);
userSettings.subscribe(value => {    
    sessionStorage.setItem("userSettings", value === null ? null : value);
});

export const branding = writable({
    theme: 'default',
    name: 'GTDeploy',
    company: 'GTMaritime',
    referrer: 'localhost:17073',
    logoOnly: false,
    basicProductName: 'GTDeploy Basic',
    proProductName: 'GTDeploy'
});